// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f56ceedc] .v-pagination__item,[data-v-f56ceedc] .v-pagination__navigation{-webkit-box-shadow:none;box-shadow:none;background:none!important}[data-v-f56ceedc] .v-pagination__item:focus,[data-v-f56ceedc] .v-pagination__navigation:focus{outline-width:1px}.v-pagination[data-v-f56ceedc]{width:unset}", ""]);
// Exports
module.exports = exports;
